const ProductTypes = {
  swagmagic: "swagmagic",
  snacks: "snacks",
  snacksKit: "snacks_kit",
  dsd: "dsd",
  medley: "medley",
  themedBox: "box",
  giftCard: "gift_card",
  byo: "international_medley",
};

export const DETAIL_PAGE_ADDITIONAL_ITEMS_PER_PAGE = 12;

export const NO_RESTRICTION_OPTION_ID = "0";
export const NO_RESTRICTION_OPTION = {
  icon: null,
  name: "No Restriction",
  id: NO_RESTRICTION_OPTION_ID,
  externalId: NO_RESTRICTION_OPTION_ID,
};
export const DEFAULT_QUANTITY = 1;
export const OPTIONTYPE_COLOR_KEY = "color";
export const OPTIONTYPE_SIZE_KEY = ["size", "locker_size"];
export const OPTIONTYPE_PACK_KEY = "pack";
export const OPTIONTYPE_PRICE_KEY = "rewards";
export const DIETARY_RESTRICTION_OTHER_KEY = "other";
export const PACK_OF_ONE_OPTION_TYPE_NAME = "1";
export const OPTIONTYPE_ONLY_SIZE_KEY = "size";

export const { swagmagic, snacks, snacksKit, dsd, medley, themedBox, giftCard, byo } = ProductTypes;

export const WAREHOUSE_PRODUCT = "Spree::WarehouseProduct";

export const SPREE_MEDLEY_ITEMS_SETS = "spreeMedleyItemSets";
export const SPREE_ORDER_PRODUCTS_SETS = "spreeOrderProductSets";
export const SPREE_LINEITEMS_SETS = "spreeLineItems";

export const ON_DEMAND_PRODUCT = "on_demand";
export const LOCKER_PRODUCT = "warehouse";

export const ORDER_IN_BULK_OPTION_ID = "order-in-bulk";

export const ORDER_IN_BULK_OPTION = {
  id: ORDER_IN_BULK_OPTION_ID,
  variantId: ORDER_IN_BULK_OPTION_ID,
  name: "bulkOption",
  presentation: "Order in bulk (volume discount)",
};

export const STATE_DESIGN_COMPLETE = "design_complete";
